import { Component, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ResolvableModal} from '@softline/ui-core';
import { CommonModule } from '@angular/common';

import { SecureImagePipe } from '@softline/ui-core';
@Component({
  selector: 'lib-image-dialog',
  imports: [CommonModule,
    SecureImagePipe],
  templateUrl: './image-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./image-dialog.component.css'] })
export class ImageDialogComponent extends ResolvableModal<any> implements OnInit {
  src = input.required<string>();
  alt = input<string>();

  ngOnInit(): void {}
}
